import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { FloatingPortal } from '@floating-ui/react';
import { IconExitToApp } from '@travel-frontend/icons';
import { useTranslation } from 'next-i18next';
import { Dropdown } from '../../../components/LoginControl/components/Dropdown.js';
import { DropdownContent } from '../../../components/LoginControl/components/DropdownContent.js';
import { DropdownItem } from '../../../components/LoginControl/components/DropdownItem.js';
import { Fade } from '../../../primitives/index.js';
export const AccountDropdown = ({
  onLogoutClick,
  floatingStyles,
  refs,
  infoVisible,
  getFloatingProps
}) => {
  const {
    t
  } = useTranslation();
  return _jsx(FloatingPortal, {
    children: _jsx(Fade, {
      in: infoVisible,
      children: _jsx(Dropdown, {
        ref: refs.setFloating,
        style: floatingStyles,
        ...getFloatingProps(),
        children: _jsx(DropdownContent, {
          children: _jsxs(DropdownItem, {
            onClick: onLogoutClick,
            children: [t('headerNew:logout'), _jsx(IconExitToApp, {})]
          })
        })
      })
    })
  });
};